import React, { ReactElement } from 'react';
import { CourseAlertBanner } from '../../../ReduxStorage/Courses/CourseAlertBanners/selectors';
import { PaymentFailureBanner } from './PaymentFailureBanner';
import { TrialCountDownBanner } from './TrialCountDownBanner';

import './styles.scss';
import { LearnerUsageExceededBanner } from '../../components/SubscriptionsHelper/LearnerUsageExceededBanner/component';

export const CourseAlertBanners = ({
  banners,
  onEducatorTrialBannerClick,
  onPersonalTrialBannerClick,
  onManageSubscriptionsClick,
}: {
  banners: Array<CourseAlertBanner>;
  onEducatorTrialBannerClick: () => void;
  onPersonalTrialBannerClick: () => void;
  onManageSubscriptionsClick: () => void;
}): ReactElement => {
  return (
    <div className="course-alert-banners">
      {banners.map((banner) => {
        switch (banner.type) {
          case 'educator-trial':
            return (
              <TrialCountDownBanner
                planName="OpenLearning Educator Account"
                daysRemaining={banner.daysRemaining}
                ctaLabel="Subscribe"
                onCtaClick={onEducatorTrialBannerClick}
                key={banner.type}
              />
            );
          case 'personal-trial':
            return (
              <TrialCountDownBanner
                planName="OpenLearning Personal Plan"
                daysRemaining={banner.daysRemaining}
                ctaLabel="Manage subscription"
                onCtaClick={onPersonalTrialBannerClick}
                key={banner.type}
              />
            );
          case 'payment-failure':
            return (
              <PaymentFailureBanner
                onClick={onManageSubscriptionsClick}
                key={banner.type}
              />
            );
          case 'exceeded-usage':
            return (
              <LearnerUsageExceededBanner
                key={banner.type}
                isOwner={banner.canManage}
                limitType={banner.limitType}
                onClick={onManageSubscriptionsClick}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
